export interface Attachment {
  id: string;
  name: string;
  size: number;
  mime: string;
  url?: string;
  state: 'uploading' | 'ready' | 'error';
  progress?: number;
  error?: string;
}

export function attachmentKind(mime: string): 'image' | 'pdf' | 'file' {
  if (/^image\/(png|jpeg|gif|webp|avif)$/i.test(mime)) return 'image';
  return mime.toLowerCase() === 'application/pdf' ? 'pdf' : 'file';
}

export function fileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return 'Размер неизвестен';
  if (bytes < 1024) return new Intl.NumberFormat('ru-RU').format(bytes) + ' Б';
  const unit = bytes < 1024 ** 2 ? 1024 : 1024 ** 2;
  return (
    new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 }).format(bytes / unit) +
    (unit === 1024 ? ' КБ' : ' МБ')
  );
}

export function fileType(name: string, mime: string): string {
  if (mime === 'application/pdf') return 'PDF';
  const ext = name.includes('.') ? name.split('.').at(-1) : '';
  return ext && ext.length <= 8 ? ext.toUpperCase() : 'ФАЙЛ';
}

export function attachmentError(file: Pick<File, 'size' | 'name'>, maxBytes: number): string | null {
  if (!file.name.trim()) return 'У файла нет имени';
  if (file.size > maxBytes) return 'Файл больше ' + fileSize(maxBytes);
  return null;
}
